import { useState } from 'react';
import { questions } from './quiz';

const result = [
  { id: 1, correct: false },
  { id: 2, correct: false },
  { id: 3, correct: false },
  { id: 4, correct: false },
  { id: 5, correct: false }
]

function App() {
  const [quizQuestions, setQuizQuestions] = useState(questions);
  const [getAnswer, setGetAnswer] = useState(result)
  const [gameOn, setGameOn] = useState(false);
  const [isAnswer, setIsAnswer] = useState(false);
  const [totalCorrect, setTotalCorrect] = useState(0)

  const setAnswer = (name, id) => {
    setQuizQuestions(quizQuestions.map((game) => game.id === id ? { ...game, isHeld: true, clicked: name } : game));
    const singleData = quizQuestions.filter((quiz) => quiz.id === id).some((item) => item.answer === name)
    //const check = singleData.some((item) => item.answer === name);
    setGetAnswer(getAnswer.map((item) => item.id === id ? { ...item, correct: singleData } : item));
  }

  const checkAnswer = () => {
    setIsAnswer(true)
    setTotalCorrect(getAnswer.filter((item) => item.correct === true).length);
  }

  const playAgain = () => {
    setGameOn(true)
    setIsAnswer(false)
    setQuizQuestions(questions)
  }

  return (
    <div className="quizzical-box">
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      {gameOn ?
        <>
          {quizQuestions.map((question) => <div key={question.id} className='question-box'>
            <h2>{question.title}</h2>
            {question.options.map((option) =>
              <div key={option}>
                <button
                  style={{ backgroundColor: question.isHeld && !isAnswer && question.clicked === option.a ? "#D6DBF5" : "" }}
                  className={`
                    ${question.isHeld && isAnswer ? "not-allowed" : ''} 
                    ${isAnswer && question.answer === option.a ? "right-ans" : ''}                    
                    ${isAnswer && question.clicked === option.a ? "wrong" : ""}`}
                  onClick={() => setAnswer(option.a, question.id)}>
                  {option.a}
                </button>
                <button
                  style={{ backgroundColor: question.isHeld && !isAnswer && question.clicked === option.b ? "#D6DBF5" : "" }}
                  className={`
                    ${question.isHeld && isAnswer ? "not-allowed" : ''} 
                    ${isAnswer && question.answer === option.b ? "right-ans" : ''}
                    ${isAnswer && question.clicked === option.b ? "wrong" : ""}`}
                  onClick={() => setAnswer(option.b, question.id)}>
                  {option.b}
                </button>
                <button
                  style={{ backgroundColor: question.isHeld && !isAnswer && question.clicked === option.c ? "#D6DBF5" : "" }}
                  className={`
                    ${question.isHeld && isAnswer ? "not-allowed" : ''} 
                    ${isAnswer && question.answer === option.c ? "right-ans" : ''}
                    ${isAnswer && question.clicked === option.c ? "wrong" : ""}`}
                  onClick={() => setAnswer(option.c, question.id)}>
                  {option.c}
                </button>
                <button
                  style={{ backgroundColor: question.isHeld && !isAnswer && question.clicked === option.d ? "#D6DBF5" : "" }}
                  className={`                    
                    ${question.isHeld && isAnswer ? "not-allowed" : ''} 
                    ${isAnswer && question.answer === option.d ? "right-ans" : ''}
                    ${isAnswer && question.clicked === option.d ? "wrong" : ""}`}
                  onClick={() => setAnswer(option.d, question.id)}>
                  {option.d}
                </button>
              </div>
            )}
          </div>)}
          {isAnswer && <h4>You scored {totalCorrect}/5 correct answers</h4>}
          <button onClick={() => isAnswer ? playAgain() : checkAnswer()} className='quiz-btn'>
            {isAnswer ? "Play Again" : 'Check Answer'}
          </button>
        </> :
        <div className='quiz-intro'>
          <h1>Quizzical</h1>
          <p>Take learning to the next level</p>
          <button onClick={() => setGameOn(true)} className='quiz-btn'>Start Quiz</button>
        </div>
      }

    </div >
  );
}

export default App;
